import { PureComponent } from 'react';
import { SelectField } from 'components/forms/Select';
import { options } from 'helpers/fieldOptions/car/transmission';
import { TRANSMISSION_NAME } from '../../../../../../constants';

const fieldOptions = options.map(({ name, value, ...rest }) => ({
  ...rest,
  name,
  value: { [name]: true },
}));

export default class TransmissionItem extends PureComponent {
  render() {
    return (
      <SelectField
        clearable
        filterInput={{ type: 'string' }}
        name={TRANSMISSION_NAME}
        options={fieldOptions}
        placeholder={__('search.filters.any')}
        {...this.props}
      />
    );
  }
}
